export enum MdhScopes {
    Global = 1,
    Affiliate = 2,
}
